import { UseQueryResult, useQuery } from "@tanstack/react-query";
import TestsListResponse from "../../../models/API/responseModels/testsListResponse.model";
import axiosInstance from "../../../api";

function usePublicTestsList(): UseQueryResult<TestsListResponse, any> {
  return useQuery({
    queryKey: ["publicTestsList"],
    queryFn: () =>
      axiosInstance.get("/v1/test-type/public-tests").then((res) => res.data),
    staleTime: Infinity,
  });
}

export default usePublicTestsList;
